import './Loader.scss';
import { TransitionGroup, CSSTransition } from 'react-transition-group';

interface LoaderProps {
  show: boolean;
  className?: string;
  animate?: boolean;
}

const LoadComponent = ({ show, className }: LoaderProps) =>
  show ? <div className={className} /> : <></>;

const animationTimeout = 240;

const Loader = ({ show = false, className = '', animate = false }: LoaderProps) => {
  const component = <LoadComponent show={show} className={className} />;

  if (!animate) return component;

  return (
    <TransitionGroup>
      {show && (
        <CSSTransition timeout={animationTimeout} classNames="fadeTransition">
          {component}
        </CSSTransition>
      )}
    </TransitionGroup>
  );
};

export default Loader;
